export default class BottomNavigationButtonClass {
    icon: JSX.Element;
    onClick: () => void;

    constructor(icon: JSX.Element, onClick: () => void) {
        this.icon = icon;
        this.onClick = onClick;
    }
}
